import AssuranceZone from 'components/AssuranceZone/AssuranceZone';

export default AssuranceZone;
